/**
 * Module-singleton counter for the toolbar's canvas-image loading progress bar.
 *
 * Any component that loads a canvas image (ArtworkNode, VaseElement, useImage …)
 * calls canvasLoadStart() when a fetch begins and canvasLoadDone() when it
 * finishes (success, error, or cancellation).  The Toolbar listens to the
 * 'canvas:loading:change' CustomEvent and reads event.detail.pending to drive
 * the progress bar.
 */

let _pendingCount = 0;

export function canvasLoadStart(): void {
  _pendingCount++;
  try {
    window.dispatchEvent(
      new CustomEvent('canvas:loading:change', { detail: { pending: _pendingCount } })
    );
  } catch (_) { /* ignore */ }
}

export function canvasLoadDone(): void {
  if (_pendingCount > 0) _pendingCount--;
  try {
    window.dispatchEvent(
      new CustomEvent('canvas:loading:change', { detail: { pending: _pendingCount } })
    );
  } catch (_) { /* ignore */ }
}
